import recruitStaff from "../../../assets/recruit-staff-handoff2.jpg";

export default function Recruit() {
  return (
    <>
      <section className="recruit-section" id="recruit">
        <div className="max-w-6xl mx-auto px-4 md:px-8 recruit-inner">
          <div className="recruit-copy">
            <p className="recruit-label">RECRUIT</p>
            <h2 className="recruit-title">
              スタッフ
              <br />
              大募集‼️
            </h2>

            <p className="recruit-lead">
              KOBE ミナトマチカレーでは、オープンしたばかりのお店を
              一緒に盛り上げてくれるスタッフを募集しています。
            </p>

            <p className="recruit-text">
              神戸の港町をイメージした新しいカレー専門店で、
              お客様に"おいしい"と"わくわく"を届けるお仕事です。
              <br />
              明るく元気に接客したい方、飲食のお仕事が好きな方、
              新しいお店づくりに関わりたい方をお待ちしています。
            </p>

            <div className="recruit-points">
              <div className="recruit-point">◎ 未経験OK</div>
              <div className="recruit-point">◎ フードコート内で働きやすい</div>
              <div className="recruit-point">◎ オープンしたばかりの新店</div>
            </div>

            <a
              href="https://www.baitoru.com/op617952/"
              target="_blank"
              rel="noopener noreferrer"
              className="recruit-btn"
            >
              応募・お問い合わせはこちら
            </a>
          </div>

          <div className="recruit-visual">
            <div className="recruit-photo-card">
              <img
                src={recruitStaff}
                alt="カウンター内からトレーに乗せた商品を手渡すスタッフ"
              />
              <div className="recruit-photo-overlay">
                <span className="overlay-badge">STAFF WANTED</span>
                <p className="overlay-text">
                  笑顔でお渡しする、
                  <br />
                  はじまりの一皿。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        /* ===== Recruit Section ===== */
        .recruit-section{
          position: relative;
          padding: 88px 0;
          background:
            linear-gradient(180deg, #fffdf8 0%, #f7f0e1 100%);
          overflow: hidden;
        }

        .recruit-section::before{
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 10px;
          background: repeating-linear-gradient(
            45deg,
            #d8b878 0 6px,
            #b98d43 6px 12px
          );
        }

        .recruit-inner{
          display: grid;
          grid-template-columns: 1.05fr 0.95fr;
          gap: 42px;
          align-items: center;
        }

        .recruit-copy{
          position: relative;
          z-index: 2;
        }

        .recruit-label{
          display: inline-block;
          margin-bottom: 14px;
          padding: 6px 14px;
          background: #17335c;
          color: #fff;
          font-size: 13px;
          font-weight: 800;
          letter-spacing: 0.08em;
          border-radius: 999px;
        }

        .recruit-title{
          margin: 0 0 18px;
          color: #d8352f;
          font-family: "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", "Meiryo", sans-serif;
          font-size: clamp(32px, 4.6vw, 50px);
          font-weight: 900;
          line-height: 1.15;
          letter-spacing: -0.02em;
          -webkit-text-stroke: 0.6px #d8352f;
        }

        .recruit-lead{
          margin: 0 0 14px;
          color: #17335c;
          font-family: "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", "Meiryo", sans-serif;
          font-size: 18px;
          font-weight: 900;
          line-height: 1.8;
        }

        .recruit-text{
          margin: 0 0 22px;
          color: #4f4436;
          font-family: "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", "Meiryo", sans-serif;
          font-size: 15px;
          font-weight: 700;
          line-height: 2;
        }

        .recruit-points{
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 26px;
        }

        .recruit-point{
          padding: 10px 14px;
          background: #fff;
          border: 1px solid #eadcc1;
          border-radius: 999px;
          color: #17335c;
          font-family: "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", "Meiryo", sans-serif;
          font-size: 14px;
          font-weight: 800;
          box-shadow: 0 6px 18px rgba(23, 51, 92, 0.06);
        }

        .recruit-btn{
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 52px;
          padding: 0 28px;
          background: #d8352f;
          color: #fff;
          text-decoration: none;
          font-size: 15px;
          font-weight: 800;
          border-radius: 999px;
          box-shadow: 0 10px 24px rgba(216, 53, 47, 0.24);
          transition: transform .2s ease, box-shadow .2s ease;
        }

        .recruit-btn:hover{
          transform: translateY(-2px);
          box-shadow: 0 14px 28px rgba(216, 53, 47, 0.30);
        }

        .recruit-visual{
          position: relative;
        }

        .recruit-photo-card{
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          background: #ddd;
          box-shadow: 0 18px 40px rgba(23, 51, 92, 0.14);
          border: 6px solid #fff;
        }

        .recruit-photo-card img{
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          aspect-ratio: 4 / 5;
        }

        .recruit-photo-overlay{
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          padding: 18px 20px 20px;
          background: linear-gradient(
            180deg,
            rgba(0,0,0,0) 0%,
            rgba(18,25,35,0.72) 100%
          );
          color: #fff;
        }

        .overlay-badge{
          display: inline-block;
          margin-bottom: 10px;
          padding: 5px 10px;
          background: #f4c53f;
          color: #17335c;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.06em;
        }

        .overlay-text{
          margin: 0;
          font-size: 22px;
          font-weight: 900;
          line-height: 1.4;
          letter-spacing: -0.02em;
        }

        /* ===== Responsive ===== */
        @media (max-width: 900px){
          .recruit-inner{
            grid-template-columns: 1fr;
            gap: 28px;
          }

          .recruit-copy{
            order: 2;
          }

          .recruit-visual{
            order: 1;
          }

          .recruit-title{
            font-size: clamp(30px, 8vw, 44px);
          }

          .recruit-lead{
            font-size: 16px;
          }

          .overlay-text{
            font-size: 20px;
          }
        }
      `}</style>
    </>
  );
}
